import React, { useState } from "react";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";

const GstPaymentModal = ({ companyId, pendingAmount, onClose, onSuccess }) => {
  const [amount, setAmount] = useState(pendingAmount);
  const [bank, setBank] = useState("HDFC Bank Account");
  const [challan, setChallan] = useState("");
  const [paymentDate, setPaymentDate] = useState(new Date().toISOString().split("T")[0]);
  const [loading, setLoading] = useState(false);

  const handleSettle = async () => {
    if (!challan) return alert("Please enter Challan/Reference Number");
    
    setLoading(true);
    try {
      const payload = {
        companyId: companyId,
        amount: parseFloat(amount),
        bankAccountName: bank,
        challanNumber: challan,
        paymentDate: paymentDate
      };

      
      await apiService.post(config.SETTLEGSTPAYMENT, payload);
      onSuccess();
      onClose();
    } catch (error) {
      console.error(error);
      alert("Error recording payment");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="gst-modal-overlay">
      <div className="gst-modal-content">
        <div className="modal-header">
          <h4>Settle GST Liability</h4>
          <button className="close-x" onClick={onClose}>&times;</button>
        </div>
        
        <div className="modal-body">
          <div className="info-box">
            <small>Pending Net Liability</small>
            <h5>INR {pendingAmount.toLocaleString("en-IN")}</h5>
          </div>

          <div className="form-group">
            <label>Amount to Pay</label>
            <input type="number" className="form-control" value={amount} onChange={e => setAmount(e.target.value)} />
          </div>

          <div className="form-group">
            <label>Paid From (Bank Account)</label>
            <select className="form-control" value={bank} onChange={e => setBank(e.target.value)}>
              <option value="HDFC Bank Account">HDFC Bank Account</option>
              <option value="Main Bank Account">Main Bank Account</option>
              <option value="Cash Account">Cash Account</option>
            </select>
          </div>

          <div className="form-group">
            <label>GST Challan / Ref Number</label>
            <input type="text" className="form-control" placeholder="CPIN / Ref Number" value={challan} onChange={e => setChallan(e.target.value)} />
          </div>

          <div className="form-group">
            <label>Payment Date</label>
            <input type="date" className="form-control" value={paymentDate} onChange={e => setPaymentDate(e.target.value)} />
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose}>Cancel</button>
          <button className="btn-confirm" onClick={handleSettle} disabled={loading}>
            {loading ? "Processing..." : "Confirm Settlement"}
          </button>
        </div>
      </div>

      <style jsx>{`
        .gst-modal-overlay {
          position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.8); display: flex; justify-content: center; align-items: center;
          z-index: 3000; font-family: sans-serif;
        }
        .gst-modal-content {
          background: #fff; width: 400px; border-radius: 8px; overflow: hidden; color: #333;
        }
        .modal-header {
          padding: 15px 20px; background: #f8f9fa; border-bottom: 1px solid #eee;
          display: flex; justify-content: space-between; align-items: center;
        }
        .modal-header h4 { margin: 0; font-size: 16px; color: #0056b3; }
        .close-x { background: none; border: none; font-size: 24px; cursor: pointer; color: #999; }
        
        .modal-body { padding: 20px; }
        .info-box { background: #eef6ff; padding: 12px; border-radius: 6px; margin-bottom: 20px; border: 1px solid #d0e3ff; }
        .info-box small { color: #555; text-transform: uppercase; font-size: 10px; font-weight: bold; }
        .info-box h5 { margin: 5px 0 0 0; color: #0056b3; font-size: 20px; }

        .form-group { margin-bottom: 15px; }
        .form-group label { display: block; font-size: 12px; font-weight: bold; margin-bottom: 5px; color: #666; }
        .form-control { width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px; box-sizing: border-box; }

        .modal-footer { padding: 15px 20px; display: flex; justify-content: flex-end; gap: 10px; background: #f8f9fa; }
        .btn-cancel { background: #6c757d; color: #fff; border: none; padding: 8px 15px; border-radius: 4px; cursor: pointer; }
        .btn-confirm { background: #28a745; color: #fff; border: none; padding: 8px 15px; border-radius: 4px; cursor: pointer; font-weight: bold; }
        .btn-confirm:disabled { opacity: 0.6; }
      `}</style>
    </div>
  );
};

export default GstPaymentModal;